import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CareGap`;

const updateCareGapByUser = async (payload) => {
  try {
    const response = await axios.put(API_URL, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating care gap:", error?.response?.data || error);
    throw error;
  }
};

export default updateCareGapByUser;
